<lucide-icon
  [name]="name"
  [size]="pixelSize"
  [strokeWidth]="strokeWidth"
  [absoluteStrokeWidth]="absoluteStrokeWidth">
</lucide-icon>
